import { Component } from '@angular/core';
import { NavParams, Platform, ViewController } from 'ionic-angular';
import { Subject } from 'rxjs/Subject';
import { DemoBarcode, ServerProviderMock } from '../rest-server/server-provider-mock';

@Component({
    templateUrl: './demo-barcodes.html'
})
export class DemoBarcodesPage {
    public character;
    public subject: Subject<string>;

    public barcodes: Array<DemoBarcode>;

    constructor(
        public platform: Platform,
        public params: NavParams,
        public viewCtrl: ViewController
    ) {
        this.subject = this.params.get('subject');
        this.barcodes = ServerProviderMock.getDemoBarcodes();
    }

    public dismiss(barcode: string) {
        this.viewCtrl.dismiss();
        this.subject.next(barcode);
        this.subject.complete();
    }
}



// WEBPACK FOOTER //
// ./src/providers/scan-provider/demo-barcodes.ts